import { Link } from "react-router-dom";

// Sharp-edged luxe CTA. filled=gold outline over navy; solid=ivory fill.
export function LuxeLink({ to, children, variant = "outline", className = "", onClick, ...props }) {
  const base =
    "group relative inline-flex items-center justify-center px-8 py-4 text-xs md:text-[13px] font-medium tracking-[0.2em] uppercase transition-colors duration-500 ease-[cubic-bezier(0.16,1,0.3,1)]";
  const styles = {
    outline: "border border-gold/50 text-ivory hover:border-gold hover:text-gold",
    solid: "bg-ivory text-navy hover:bg-gold",
    ghost: "text-ivory/70 hover:text-gold border-b border-transparent hover:border-gold",
  };
  const cls = `${base} ${styles[variant]} ${className}`;
  if (to) {
    return (
      <Link to={to} className={cls} onClick={onClick} {...props}>
        {children}
      </Link>
    );
  }
  return (
    <button className={cls} onClick={onClick} {...props}>
      {children}
    </button>
  );
}
